import { replaceTokensWithComponents } from '@cat-ecom/common/utils/stringUtils';
import { CatButton } from 'blocks-nextjs/blocks-react/components/Button';
import { B2C_LOGIN_URL } from 'constants/links';
import { useTranslations } from 'next-intl';
import { useParams, usePathname } from 'next/navigation';
import { getSeoUrl, normalizeCommerceLink } from 'utils/links';

type DealerLocatorCreateAccountDescriptionProps = {
  redirectionUrl?: string;
}

const DealerLocatorCreateAccountDescription = ({ redirectionUrl = '' }: DealerLocatorCreateAccountDescriptionProps) => {
  const t = useTranslations();
  // TODO - Input Validation - Ensure that all values used from params are allowed values:
  // lang should always be a two-digit string without numbers or special characters (like 'es');
  // esite should always be a string without numbers or special characters, except for the dash (like demo-dealer).
  const params = useParams();
  const esiteUrl = getSeoUrl(params);
  /*
    TODO - Input Validations - usePathName: string except the
    generalRestrictedCharacters (@\constants\securityConstants.ts)
  */
  const pathname = usePathname();
  const isHomePage = esiteUrl === pathname;
  const loginUrl = normalizeCommerceLink(
    getSeoUrl(params, B2C_LOGIN_URL, {
      pageRedirectUrl: redirectionUrl || pathname,
      loginFromHomePage: isHomePage
    })
  );

  return (
    <>
      {`${t('REGISTER_MODAL_STEPS_SUBTITLE')}`}
      <br />
      <br />
      {`1) ${t('REGISTER_MODAL_1_SELECT_LOCAL_STORE')}`}
      <br />
      {`2) ${t('REGISTER_MODAL_2_CREATE_LOCAL_PROFILE')}`}
      <br />
      {`3) ${t('REGISTER_MODAL_3_VERIFY_EMAIL_ADDRESS')}`}
      <br />
      {`4) ${t('REGISTER_MODAL_4_CREATE_CAT_ACCOUNT')}`}
      <br />
      <br />
      {replaceTokensWithComponents(
        t('REGISTER_MODAL_SIGN_IN_PROMPT', { '0': '{0}' }),
        <CatButton
          type="button"
          size="lg"
          variant="inline"
          className="cat-u-theme-typography-body"
          href={loginUrl}
        >
          {t('SIGN_IN')}
        </CatButton>
      )}
    </>
  );
};

export { DealerLocatorCreateAccountDescription };
